import React, { useEffect } from 'react';
import { BrowserRouter as Router, useNavigate, useLocation } from 'react-router-dom';
import Main from './components/Layout/main';
import { ToastContainer } from 'react-toastify';
import { UserProvider } from "./context/UserContext";
import SecureCookieManager from './utils/secureCookie';
import { getV2Token, optimizeV2CookiesBeforeNavigation } from './utils/v2AuthUtils';
import { validateToken } from './utils/tokenValidator';

import './styles/_variables.css';
import './styles/app.css';
import './styles/theme.css';
import './i18n'
import InactivityHandler from './components/Layout/InActivityHandler';
import i18n from './i18n';
import { getCurrentLanguage } from './utils/languageUtils';

const AppContent = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // CRITICAL: Optimize cookies on mount AND on every route change
        // This prevents "Request Header Or Cookie Too Large" errors by cleaning up
        // orphaned/duplicate cookies before they cause issues
        optimizeV2CookiesBeforeNavigation();
        
        // Authentication is now handled by ProtectedRoute component
        // This effect only handles initial token sync from v2-frontend cookies
        const syncTokenFromV2 = () => {
            if (location.pathname === '/login' || location.pathname === '/register') {
                return; // Allow access to login/register pages
            }

            // Check for token from v2-frontend cookies and sync it
            const v2Token = getV2Token();
            
            if (v2Token) {
                console.log('[front_compliance] Found token from v2-frontend cookies, syncing...');
                // Validate token client-side (same as new_demo_frontend)
                const userData = validateToken(v2Token);
                if (userData) {
                    // Only set cookies if they don't already exist to avoid duplicates
                    const existingToken = SecureCookieManager.getAuthToken();
                    if (!existingToken || existingToken !== v2Token) {
                        SecureCookieManager.setAuthToken(v2Token);
                    }
                    
                    const existingUserData = SecureCookieManager.getUserData();
                    if (!existingUserData || JSON.stringify(existingUserData) !== JSON.stringify(userData)) {
                        SecureCookieManager.setUserData(userData);
                    }
                    console.log('[front_compliance] Token synced successfully');
                } else {
                    console.warn('[front_compliance] Token validation failed');
                }
            }
        };

        // Sync token on mount (with small delay to ensure cookies are available after optimization)
        const timeoutId = setTimeout(() => {
            syncTokenFromV2();
        }, 100);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [location.pathname]);

    return <Main />;
};
 const currentLanguage = getCurrentLanguage();
    document.documentElement.lang = currentLanguage;
    document.documentElement.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';

function App() {
    return (
        <UserProvider>
            <Router>
                <ToastContainer autoClose={5000} hideProgressBar />
                <AppContent />
                <InactivityHandler/>
            </Router>
          
        </UserProvider>
    );
}

export default App;
